/*
 * Copyright (C) 2021 The Hunter2 Contributors.
 *
 * This file is part of Hunter2.
 *
 * Hunter2 is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * Hunter2 is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A
 * PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with Hunter2.  If not, see <http://www.gnu.org/licenses/>.
 */

import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import distinctColors from 'distinct-colors'

Chart.register(
  Legend,
  BarElement,
  LineElement,
  PointElement,
  LineController,
  BarController,
  CategoryScale,
  LinearScale,
  Tooltip,
  ChartDataLabels,
)

for (let canvas of document.getElementsByClassName('trends-chart')) {
  let data = JSON.parse(document.querySelector(
    `.stat-size-${canvas.dataset.sizeAware} .trends-data-container script`,
  ).textContent)
  let datasetNames = data.datasets[canvas.dataset.dataset][1]
  let colours_ = distinctColors({count: datasetNames.length, chromaMin: 30, chromaMax: 90, lightMin: 50, lightMax: 80})
  let colours = Object.fromEntries(datasetNames.map((name, i) => [name, colours_[i]]))
  let events = data.events
  let labels = data.labels
  let format = data.format[canvas.dataset.dataset]

  let ctx = canvas.getContext('2d')

  let config = {
    type: 'line',
    data: {
      labels: events,
      datasets: datasetNames.map(function(datasetName) { return {
        data: data.series[datasetName],
        backgroundColor: colours[datasetName],
        borderColor: colours[datasetName],
        borderWidth: 2,
        label: labels[datasetName],
        datalabels: {
          labels: {
            total: {
              formatter: format['percent'] ? function(value) {
                return (value * 100).toFixed(1) + '%'
              } : function(value) {
                return value.toLocaleString()
              },
              align: 'start',
              anchor: 'end',
            },
          },
        },
        lineTension: 0,
        pointRadius: 2,
      }}),
    },
    options: {
      plugins: {
        legend: {
          display: datasetNames.length > 1,
          labels: {
            usePointStyle: true,
            boxHeight: 2,
          },
          position: 'bottom',
          title: 'legend',
        },
      },
      layout: {
        padding: {
          left: 30,
          right: 30,
          top: 30,
          bottom: 30,
        },
      },
      scales: {
        y: {
          ticks: {
            format: format['percent'] ? {
              style: 'percent',
            } : {},
            padding: 10,
          },
        },
        x: {
          ticks: {
            padding: 10,
          },
        },
      },
    },
  }
  new Chart(ctx, config)
}
